'use client';

import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden hero-gradient grain-overlay pt-36">
      {/* Decorative circles */}
      <div className="absolute top-1/4 -left-32 w-96 h-96 rounded-full bg-navy/5 blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 -right-32 w-96 h-96 rounded-full bg-gold-pale/30 blur-3xl pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-gold-light/20 blur-3xl pointer-events-none" />

      {/* Grid pattern overlay */}
      <div
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage: `linear-gradient(rgba(201,168,76,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(201,168,76,0.3) 1px, transparent 1px)`,
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Text content */}
          <div className="text-center lg:text-left">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8 fade-in-up">
              <div className="w-2 h-2 rounded-full bg-navy animate-pulse" />
              <span className="text-white/80 text-xs font-medium tracking-wider uppercase">Cabinet agréé n° 11-1680-18</span>
            </div>

            {/* Title */}
            <div className="mb-6 fade-in-up fade-in-up-delay-1">
            </div>

            {/* Subtitle */}
            <p className="text-white/70 text-lg leading-relaxed mb-10 fade-in-up fade-in-up-delay-2">
InterConseil est un cabinet de formation, de conseil et d'audit qui accompagne les entreprises à plusieurs niveaux, de la définition de leur stratégie jusqu'à la mise en œuvre opérationnelle. Grâce à une approche personnalisée, InterConseil intervient dans le développement des compétences, l'optimisation des processus et l'amélioration de la performance globale.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-4 fade-in-up fade-in-up-delay-3">
              <a
                href="#formations"
                className="bg-navy text-gold-dark font-semibold text-base px-8 py-4 rounded-full hover:bg-navy-deep transition-all duration-300 shadow-navy-md hover:-translate-y-1"
              >
                Découvrir nos formations
              </a>
              <a
                href="#contact"
                className="border-2 border-white/40 text-white font-semibold text-base px-8 py-4 rounded-full hover:border-white hover:bg-white/10 transition-all duration-300 backdrop-blur-sm"
              >
                Demander un devis
              </a>
            </div>

            {/* Stats row */}
            <div className="mt-12 grid grid-cols-3 gap-4 fade-in-up fade-in-up-delay-4">
              {[
                { value: '5+', label: 'Domaines de formation' },
                { value: '100%', label: 'Orienté résultats' },
                { value: '20+', label: 'Formateurs experts' },
              ].map((stat) => (
                <div key={stat.label} className="text-center lg:text-left">
                  <div className="text-3xl font-bold text-navy font-serif">{stat.value}</div>
                  <div className="text-white/50 text-xs mt-1 leading-tight">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Training photos mosaic */}
          <div className="hidden lg:grid grid-cols-2 gap-3 fade-in-up fade-in-up-delay-2">
            <div className="space-y-3">
              <div className="rounded-2xl overflow-hidden h-48 shadow-lg">
                <img
                  src="/assets/images/IMG_0272-1774975649159.JPG"
                  alt="Formateur Inter Conseil animant une session de formation professionnelle devant un auditoire en salle"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-2xl overflow-hidden h-36 shadow-lg">
                <img
                  src="/assets/images/IMG_0270-1774975804661.JPG"
                  alt="Session de formation en salle de réunion avec participants autour d'une table et présentateur debout"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="space-y-3 mt-6">
              <div className="rounded-2xl overflow-hidden h-48 shadow-lg">
                <img
                  src="/assets/images/IMG_0269-1774977157880.JPG"
                  alt="Quatre professionnels souriants lors d'une réunion de formation autour d'une table avec un laptop"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 fade-in-up fade-in-up-delay-4">
        <span className="text-white/40 text-xs tracking-widest uppercase">Défiler</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/30 to-transparent" />
      </div>
    </section>
  );
};

export default HeroSection;